import { createRouter, createWebHistory } from 'vue-router';
import { middlewareLayout } from './middleware';
import { useAuthStore } from '@/stores/auth.js';

import NotFound from '@/views/NotFound.vue';
import nurse from './modules/nurse.js';
import customer from './modules/customer.js';

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
      path: '/',
      hidden: true,
    },
		{
			path: '/404',
			name: 'NotFound',
			component: NotFound,
			meta: {
				layout: 'Empty',
			},
		},
		{ path: '/:pathMatch(.*)*', name: 'DefaultNotFound', component: NotFound },
		...nurse,
		...customer,
	],
});

router.beforeEach((to, from, next) => {
	const mode = localStorage.getItem('mode');
	const authStore = useAuthStore();

	middlewareLayout(to, from, next);
});

router.afterEach(() => {
	setTimeout(() => {
		if (window) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}, 200);
});

export default router;
